<template>
	
    <div class="vpay__content-area" v-loading="loading">
		
		<h2 class="vpay__title-bar"><ion-icon class="vpay__title-bar-close" name="arrow-back" @click="onClickClose"></ion-icon>Create Account</h2>
		
		<el-row>
			
			<el-col :span="12">
				<div class="vpay__input-container" style="padding-right: 6px">
					<label>First Name</label>
					<input class="vpay__input vpay__input--small" type="text" v-model="firstName">
				</div>
			</el-col>
			
			<el-col :span="12">
				<div class="vpay__input-container" style="padding-left: 6px">
					<label>Last Name</label>
					<input class="vpay__input vpay__input--small" type="text" v-model="lastName">
				</div>
			</el-col>
			
			<el-col :span="24">
				<div class="vpay__input-container">
					<label>Email Address</label>
					<input class="vpay__input vpay__input--small" type="text" v-model="emailAddress">
				</div>
			</el-col>
			
			<el-col :span="24">
				<hr class="vpay__divider">
			</el-col>
			
			<el-col :span="24">
				<div class="vpay__input-container">
					<label>Password</label>
					<input class="vpay__input vpay__input--small" type="password" v-model="password">
				</div>
			</el-col>
			
			<el-col :span="24">
				<div class="vpay__input-container">
					<label>Confirm Password</label>
					<input class="vpay__input vpay__input--small" type="password" v-model="confirmPassword">
				</div>
			</el-col>
			
		</el-row>
		
		<div class="vpay__input-container">
			<el-button class="vpay__next-button" type="success" @click="onClickCreateAccount" round>Create Account</el-button>
		</div>
		
    </div>
	
</template>

<script>
	
    export default {
		
        name: "CreateAccount",
		
		methods: {
			
			onClickCreateAccount() {
				
				// Validate fields.
				
				if (!this.firstName || !this.lastName || !this.emailAddress || !this.password) {
					this.$message.warning("Please fill in all of the required fields.");
					return;
				}
				
				if (this.password !== this.confirmPassword) {
					this.$message.warning("Please confirm your password.");
					return;
				}
				
				// Payload.
				
				const payload = {
					first_name: this.firstName,
					last_name: this.lastName,
					email: this.emailAddress,
					password: this.password,
				};
				
				this.loading = true;
				
				this.axios.post(`${process.env.VUE_APP_USERS_API_URL}create-account`, payload, { headers: this.$store.getters.requestHeaders2 }).then((r) => {
					if (r.data.success) {
						// Store user data.
						this.$store.commit("user", r.data.user);
						// Update stored address.
						this.$store.commit("address", {
							street_1: this.$store.getters.user.street_1,
							city: this.$store.getters.user.city,
							state: this.$store.getters.user.state,
							postcode: this.$store.getters.user.postcode,
							country: this.$store.getters.user.country,
						});
						// Close the login form.
						this.$store.commit("displayComponentName", null);
					}
				}).catch((e) => {
					this.$message.warning(e.response.data.message);
				}).finally(() => {
					this.loading = false;
				});
				
			},
			
			onClickClose() {
				this.$store.commit("displayComponentName", null);
			}
			
		},
		
		data() {
			
			return {
				
				loading: false,
				
				firstName: "",
				lastName: "",
				emailAddress: "",
				password: "",
				confirmPassword: "",
				
			};
			
		}
		
    }
	
</script>

<style>
	
	
	
</style>
